import { getRatingDetail, ratingSetting, getRatingDetailSeller } from '@/apis/rating-detail';
import { RATING_DETAIL } from '../mutation-types';

export const state = {
  dataRating: [],
  dataSellerRating: [],
};

export const getters = {
  dataRating: (state) => state.dataRating,
  dataSellerRating: (state) => state.dataSellerRating,
};

export const mutations = {
  [RATING_DETAIL.GET_RATING_DETAIL](state, data) {
    if (!data.error) {
      state.dataRating = data;
    }
  },
  [RATING_DETAIL.GET_RATING_DETAIL_SELLER](state, data) {
    if (!data.error) {
      state.dataSellerRating = data;
    }
  },
};

export const actions = {
  async getRatingDetail({ commit }, payload) {
    const res = await getRatingDetail(payload);
    commit(RATING_DETAIL.GET_RATING_DETAIL, res);
    return res;
  },
  async getRatingDetailSeller({ commit }, payload) {
    const res = await getRatingDetailSeller(payload);
    commit(RATING_DETAIL.GET_RATING_DETAIL_SELLER, res);
    return res;
  },
  async ratingSetting({ commit }, payload) {
    const res = await ratingSetting(payload);
    return res;
  },

};
